module.exports = __webpack_public_path__ + "img/undraw_time_management_re_tk5w.060b40c0.svg";